import {style} from 'typestyle'

export const main = style({
    width: '100%',
    height: '100%',
    maxWidth: '480px',
    minWidth: '320px',
    minHeight: '100%',
    position: 'relative',
    fontFamily: 'PingFangSC-Regular'
})

export const freeLectureListWrap = style({
    minHeight: '100vh',
    paddingBottom: 1,
    position: 'relative'
})



// WEBPACK FOOTER //
// ./src/views/FreeLecture/FreeLecture.style.ts